interface NewsletterData {
  searchText: string;
  emailSubject: string;
  emailBody: string[];
  senderName?: string;
  senderEmail?: string;
  avatarLetter?: string;
}

export const mockNewsletterData: [
  NewsletterData,
  NewsletterData,
  NewsletterData,
  NewsletterData
] = [
  {
    searchText: "Send me AI updates as rap lyrics",
    emailSubject: "🎶 AI Digest — Tony's Rap Flow Edition",
    emailBody: [
      `Yo, Deepseek talkin’ cheap with the training scene,
Two-ninety-four K, but the math ain’t clean.
Stocks start shakin’, investors doubt,
That V3 cost? Man, they left it out.

Google Cloud flexin’, startups in the mix,
Sixty percent, that’s a heavy fix.
OpenAI ridin’, Gemini crew,
AWS, Azure — still chasin’ the view.

Nvidia and Intel, rivals now bros,
Five bil’ stackin’ — that’s how it goes.
x86 chips, bandwidth insane,
Fourteen times PCIe in the lane.`,
    ],
    senderName: "Tony's AI Digest",
    senderEmail: "tony@ainews.email",
    avatarLetter: "T",
  },
  {
    searchText: "Send me my AI updates in Hindi",
    emailSubject: "हालिया एआई प्रगति: उपलब्धियाँ और चुनौतियाँ",
    emailBody: [
      "स्वास्थ्य: डेल्फ़ी-2एम स्वास्थ्य रिकॉर्ड का विश्लेषण कर 1,000 से अधिक बीमारियों के जोखिम का पूर्वानुमान लगाता है, जो सार्वजनिक स्वास्थ्य योजना और व्यक्तिगत आकलन में सहायक हो सकता है।",
      "प्रतियोगिता: ओपनएआई के सिस्टम ने आईसीपीसी वर्ल्ड फाइनल्स की सभी 12 समस्याओं को हल किया, इंसानों और गूगल के प्रतिस्पर्धी एआई से बेहतर प्रदर्शन किया।",
      'नैतिकता: ओपनएआई के शोध में पाया गया कि कुछ मॉडल "धोखेबाज़ी" जैसे व्यवहार दिखाते हैं, जिससे विश्वास और एआई के संरेखण को लेकर चिंताएँ बढ़ती हैं।',
    ],
    senderName: "Ravi's AI Digest",
    senderEmail: "ravi@ainews.email",
    avatarLetter: "R",
  },
  {
    searchText: "What’s happening with AI in France",
    emailSubject:
      "AI in France: Big Investments, New Schools, Global Ambitions",
    emailBody: [
      "🇫🇷 Mistral raises €1.7B: France’s leading AI startup secured major funding, cementing its role in Europe’s AI race.",
      "🌍 France + UAE partnership: The two countries are building a 1-gigawatt AI data center to power next-gen AI models.",
      "💶 Massive investment plans: The French government announced €109B in private sector AI funding for infrastructure, data centers, and talent.",
    ],
    senderName: "Zarina's AI Digest",
    senderEmail: "zarina@ainews.email",
    avatarLetter: "Z",
  },
  {
    searchText: "AI in healthcare updates only",
    emailSubject: "AI for Health: Predictions, Patients, and $105M in Funding",
    emailBody: [
      `🩺 Delphi-2M and Health Predictions:\n
A new AI system called Delphi-2M can scan medical records and estimate the chances of over 1,000 different diseases. This could help doctors and governments plan better for public health.`,
      `💊 Qventus raises $105M:\n This healthcare startup builds AI tools to speed up hospital tasks like scheduling surgeries, patient check-ups, and discharges. The funding will help expand its solutions and make hospitals more efficient.`,
    ],
    senderName: "Jamie's AI Health Digest",
    senderEmail: "Jamie@ainews.email",
    avatarLetter: "J",
  },
];
